<section class="mt-4" >
  <div *ngIf="zaverecnePrace" matBadge="{{zaverecnePrace.length}}" matBadgeColor="warn" matBadgeOverlap="false" matBadgePosition="after"></div>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="h6 text-nowrap" i18n>Záverečné práce</div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div *ngIf="zaverecnePrace">
      <app-zaverecna-praca *ngFor="let zp of zaverecnePrace" [zaverecnaPraca]="zp"></app-zaverecna-praca>
    </div>
    <hr/>
    <div class="d-flex flex-row align-items-center">
      <div><b><a (click)="openPrehladZaverecnychPrac()" i18n i18n-title title="Prehľad zadaní záverečných prác a prihlásenie">Prehľad zadaní záverečných prác a prihlásenie</a></b></div>
    </div>
  </mat-expansion-panel>
</section>
